import React, { Component } from 'react';
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { collectionScrollAuto } from "../../../services/script";

class BlogList extends Component{
    render(){
        const { mainBanner, themeLayoutId } = this.props;
        return(
            <React.Fragment>

                {/* Pet Theme Start */}

                {(themeLayoutId === 'L04' || themeLayoutId === 'L02' || themeLayoutId === 'L03') &&
                <section className="blog blog-2 section-b-space ratio3_2">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                            <Slider {...collectionScrollAuto} className="slide-6 no-arrow">
                                {!!mainBanner && mainBanner.map((infocus, index) => {
                                        return (
                                                <div className="col-md-12" key={index}>
                                                    <Link to='/'>
                                                        <div className="classic-effect">
                                                            <img src={infocus.Image.APC_ELEMENT_CONTENT} className="img-fluid" alt="" />
                                                            <span></span>
                                                        </div>
                                                    </Link>
                                                    <div className="blog-details">
                                                        <h4>25 January 2018</h4>
                                                        <Link to="/">
                                                            <p>Lorem ipsum dolor sit consectetur adipiscing elit, </p>
                                                        </Link>
                                                        <hr className="style1" />
                                                        <h6>by: John Dio , 2 Comment</h6>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </section>
                }

                {/* End Pet Theme */}

            </React.Fragment>
        )
    }
}

export default BlogList